/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  OwnableLogic,
  OwnableLogicInterface,
} from "../../../../contracts/dependant/ownable/OwnableLogic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type OwnableLogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: OwnableLogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class OwnableLogic__factory extends ContractFactory {
  constructor(...args: OwnableLogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<OwnableLogic> {
    return super.deploy(overrides || {}) as Promise<OwnableLogic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): OwnableLogic {
    return super.attach(address) as OwnableLogic;
  }
  override connect(signer: Signer): OwnableLogic__factory {
    return super.connect(signer) as OwnableLogic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): OwnableLogicInterface {
    return new utils.Interface(_abi) as OwnableLogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OwnableLogic {
    return new Contract(address, _abi, signerOrProvider) as OwnableLogic;
  }
}
